export const UPDATE_STEP1_DATA = 'UPDATE_STEP1_DATA';
export const SAVE_AS_DRAFT = 'SAVE_AS_DRAFT';
export const UPDATE_STEP2_DATA = 'UPDATE_STEP2_DATA';
export const UPDATE_SELECTED_CLIENTS = 'UPDATE_SELECTED_CLIENTS';